import axios from '@/plugins/axiosInstance';
import { googleIntegration } from '@/networking/urlManager';
import { responseHandlerService } from '@/plugins/responseHandlerService';
import { isConnected, isAuthorized, hasPropertyId } from '../state';

/**
 * Yetkilendirme sorunu yaşayan Google hesabının bağlantısını kes
 * @param {string} assetId - Asset ID
 * @returns {Promise<boolean>} - İşlem başarılı oldu mu
 */
export async function revokeInvalidAccount(assetId) {
  try {
    // Direkt olarak yeni API uç noktasını kullan
    const result = await axios.post(googleIntegration.revokeInvalidToken, {
      assetId,
      revokeProperty: true // Mülk bağlantısını da kaldır
    });
    
    // İşlem başarılıysa durumları güncelle
    if (result.data && result.data.data && result.data.data.revoked) {
      // Durum güncellemesi
      isConnected.value = false;
      isAuthorized.value = false;
      hasPropertyId.value = false;
      
      // Kapsamlı bir bilgi mesajı göster - token iptal edildi, ancak Google izin yönetiminde hala görünebilir
      responseHandlerService.handleSuccess(
        result.data?.data?.message || 
        "Google Analytics hesabınızın yetkilendirmesi sıfırlandı. Not: Google hesabınızda Lobster Lead uygulamasını izinlerden manuel olarak kaldırmanız gerekebilir. Lütfen ayarlar sayfasından yeniden bağlanın."
      );
      
      return true;
    }
    
    return false;
  } catch (error) {
    responseHandlerService.handleError(
      error,
      "Google Analytics hesabınızın bağlantısı kesilirken bir hata oluştu."
    );
    return false;
  }
}